import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import { isValidPhoneNumber, parsePhoneNumber } from 'libphonenumber-js';
import { PhoneInput } from 'UI/Inputs';
import { Button } from '@haldor/ui';

var UserPhone = /*#__PURE__*/function (_Component) {
  _inherits(UserPhone, _Component);

  var _super = _createSuper(UserPhone);

  function UserPhone() {
    var _this;

    _classCallCheck(this, UserPhone);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "submit", function (values) {
      return new Promise(function (resolve) {
        if (values.mobilePhone != null && values.mobilePhone != '') {
          values.mobilePhone = '+' + values.mobilePhone;
          values.mobilePhone = parsePhoneNumber(values.mobilePhone).format('E.164');
        }

        if (_this.props.onSubmit != null) {
          _this.props.onSubmit(values).then(function () {
            resolve(1);
          })["catch"](function (error) {
            _this.setState({
              error: error
            });

            resolve(1);
          });
        } else {
          resolve(1);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "validatePhone", function (value) {
      if (value == null || value == '') {
        return undefined;
      }

      if (value.length < 5) {
        return _this.props.translate('Enter a valid phone number');
      }

      var number = '+' + value;

      if (isValidPhoneNumber(number)) {
        return undefined;
      }

      return _this.props.translate('Enter a valid phone number');
    });

    _defineProperty(_assertThisInitialized(_this), "onCancel", function (event) {
      event.preventDefault();

      if (_this.props.onCancel != null) {
        _this.props.onCancel();
      }
    });

    return _this;
  }

  _createClass(UserPhone, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          submitting = _this$props.submitting,
          handleSubmit = _this$props.handleSubmit,
          valid = _this$props.valid,
          translate = _this$props.translate;

      if (this.props.user == null) {
        return null;
      }

      var country = this.props.tenant.lcid.slice(-2);
      return /*#__PURE__*/React.createElement("div", {
        className: "form-container sms-form"
      }, submitting ? /*#__PURE__*/React.createElement("div", {
        className: "is_sending"
      }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
        className: "loading-spinner"
      }))) : null, /*#__PURE__*/React.createElement("form", {
        className: "form form-component file-upload"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row",
        style: {
          marginTop: 0
        }
      }, /*#__PURE__*/React.createElement("label", {
        style: {
          marginTop: 0
        }
      }, translate('Name')), /*#__PURE__*/React.createElement("input", {
        name: "name",
        type: "text",
        disabled: true,
        value: this.props.user.firstName + ' ' + this.props.user.lastName
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("label", null, translate('Phone number')), /*#__PURE__*/React.createElement(Field, {
        name: "mobilePhone",
        component: PhoneInput,
        validate: this.validatePhone,
        placeholder: translate('Phone number'),
        countryCode: country
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-divider"
      }), /*#__PURE__*/React.createElement("div", {
        className: "form-row spacing submit"
      }, /*#__PURE__*/React.createElement(Button, {
        disabled: submitting || !valid,
        onClick: handleSubmit(this.submit),
        type: "primary"
      }, translate('Save')), /*#__PURE__*/React.createElement("div", {
        className: "align-right"
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: this.onCancel,
        disabled: submitting,
        type: "secondary"
      }, translate('Cancel'))))));
    }
  }]);

  return UserPhone;
}(Component);

function mapStateToProps(state, ownProps) {
  return {
    translate: translate(state.Languages.translations),
    tenant: state.user.tenant,
    initialValues: ownProps.user
  };
}

export default connect(mapStateToProps)(reduxForm({
  form: 'UserPhoneForm',
  destroyOnUnmount: true
})(UserPhone));